import React, { useMemo, useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { toast } from 'react-toastify';
import Topbar from '../../layouts/Topbar';
import Sidebar from '../../layouts/Sidebar';
import { API_BASE_URL } from '../../../config/api';


const HRImportKPIs = () => {
  const baseUrl = API_BASE_URL;

  const [file, setFile] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [uploading, setUploading] = useState(false);

  const years = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return [currentYear, currentYear + 1];
  }, []);

  const templateHeaders = [
    'year',
    'key_result_area',
    'period',
    'month',
    'week',
    'activity',
    'performance_standard',
    'metric',
    'stakeholder'
  ];

  const downloadTemplate = () => {
    const sampleRow = ['1', 'Increase customer retention', '10', 'Customer Success', 'Q1', String(year)];
    const csv = [templateHeaders.join(','), sampleRow.map(v => `"${String(v).replaceAll('"', '""')}"`).join(',')].join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `kpi_bulk_template_${year}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      toast.error('Please select an Excel/CSV file to upload.');
      return;
    }

    setUploading(true);
    try {
      const token = Cookies.get('token');
      const formData = new FormData();
      formData.append('file', file);
      formData.append('year', String(year));

      await axios.post(`${baseUrl}/api/goals/bulk-create/`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      toast.success('File uploaded successfully.');
      setFile(null);
    } catch (err) {
      console.log(err);
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        err.response?.data?.error ||
        'Failed to upload file.';
      toast.error(message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
      <Topbar />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content pb-0">
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
            <div>
              <h4 className="fw-bold mb-1">Import KPIs</h4>
              <p className="text-muted mb-0 fs-13">
                Upload an Excel/CSV file to bulk-create KPIs
              </p>
            </div>
            <button
              type="button"
              onClick={downloadTemplate}
              className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
            >
              <i className="ti ti-download" /> Download Template CSV
            </button>
          </div>

          {/* Upload Card */}
          <div className="card shadow-sm max-w-700">
            <div className="card-header bg-light border-bottom py-3">
              <h6 className="card-title mb-0 fw-bold text-dark">
                Bulk KPI Upload Form
              </h6>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-medium">
                      Select Target Year <span className="text-danger">*</span>
                    </label>
                    <select
                      value={year}
                      onChange={(e) => setYear(parseInt(e.target.value))}
                      className="form-select"
                      disabled={uploading}
                    >
                      {years.map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12">
                    <label className="form-label fw-medium">
                      Excel / CSV File <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
                      disabled={uploading}
                      onChange={(e) => setFile(e.target.files?.[0] ?? null)}
                      className="form-control"
                      required
                    />
                    <div className="form-text fs-12 text-muted mt-1">
                      Supported formats: .xlsx, .xls, .csv
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-end gap-2 mt-4 pt-3 border-top">
                  <button
                    type="submit"
                    disabled={uploading}
                    className="btn btn-primary d-flex align-items-center gap-2 px-4"
                  >
                    {uploading ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        Uploading...
                      </>
                    ) : (
                      <>
                        <i className="ti ti-upload" /> Upload &amp; Submit
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
          <p className="text-dark mb-0">
            2026 © <span className="link-primary">Casoe Technologies</span>, All Rights Reserved
          </p>
        </div>
      </div>
    </div>
  );
};

export default HRImportKPIs;
